import { ErrorHandler, Injectable } from '@angular/core';

import { LoaderService } from '../../rt-shared/ui/loader/loader.service';
import { ErrorService } from './error.service';

/**
 * 全域錯誤處理器
 *
 * @export
 * @class GlobalErrorHandler
 * @implements {ErrorHandler}
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private errorService: ErrorService,
    private loaderService: LoaderService
  ) {}

  /**
   * 錯誤處理
   *
   * @param {*} err
   * @memberof GlobalErrorHandler
   */
  handleError(err: any): void {
    const newErr =
      err instanceof Error ? err : new Error(JSON.stringify(err ?? {}));
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(err.message)) {
      window.location.reload();
      return;
    }

    this.errorService.handleUnknownError(newErr);

    // 發生錯誤如果目前 Loader 是顯示的就要關掉
    if (this.loaderService.getSideMenuObservable()) {
      this.loaderService.hide();
    }
  }
}
